import { type } from 'type-r'


export function createEnum(...args) {
    const parseEnum = function (val) {
        if (val)
            val = val.toString()        
        if (typeof val == 'string') {
            return args.find(arg => val.match(new RegExp(`^${arg}$`, "i")));
        }
    }
    parseEnum.args = args;
    return type(String).parse(parseEnum).check(v => !v || args.indexOf(v) >= 0, "set to invalid value");

}
